import React from 'react';

import { List, ListItemButton, ListItemText, Paper } from '@mui/material';

import type { ChatMemberMentionCandidate } from '../../utils/chatMemberMention.utils';

interface ChatMemberMentionListProps {
  suggestions: ChatMemberMentionCandidate[];
  onSelect: (member: ChatMemberMentionCandidate) => void;
}

const ChatMemberMentionList: React.FC<ChatMemberMentionListProps> = ({ suggestions, onSelect }) => {
  if (!suggestions.length) {
    return null;
  }

  return (
    <Paper
      elevation={3}
      sx={{
        position: 'absolute',
        left: 16,
        right: 16,
        bottom: '100%',
        mb: 0.5,
        maxHeight: 180,
        overflow: 'auto',
        zIndex: 2,
      }}
    >
      <List dense disablePadding>
        {suggestions.map((member) => (
          <ListItemButton
            key={member.id}
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => onSelect(member)}
          >
            <ListItemText
              primary={member.fullName}
              primaryTypographyProps={{ fontSize: 13 }}
            />
          </ListItemButton>
        ))}
      </List>
    </Paper>
  );
};

export default ChatMemberMentionList;
